<template>
  <form class="needs-validation" @submit.prevent="update" novalidate>
    <div class="col px-0 pr-lg-3" v-if="memberDetails ? memberDetails.id ? true : false : false">

      <section class="card bg-white rounded mb-4 p-3 p-sm-4">
        <div class="d-flex align-items-center" :aria-expanded="selectedSection === 'details'" aria-controls="details" id="detailsHeading" @click.prevent="selectedSection !== 'details' ? selectedSection = 'details' : selectedSection = 'null'">
          <h1 class="h2 mb-0">{{split ? 'Split Member Details' : my ? 'My Details' : 'Details'}}</h1>
          <span class="mx-2 mx-sm-3 badge badge-info" v-if="loggedInRole !== 'Volunteer' && memberDetails.getedRole !== 'Volunteer' ? (memberDetails ? memberDetails.financial ? true : false : false) : false">Financial</span>
          <span class="mx-2 mx-sm-3 badge alert-warning" v-else-if="loggedInRole !== 'Volunteer' && memberDetails.getedRole !== 'Volunteer'">Unfinancial</span>
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-if="selectedSection === 'details' && $store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg==">
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-else-if="$store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+">
        </div>
        <div role="alert" class="alert alert-success mt-3" v-if="success">{{success}}</div>
        <div role="alert" class="alert alert-warning mt-3" v-else-if="errors">{{errors}}</div>
        <div
          role="alert"
          class="alert alert-info mt-3 mb-0 d-lg-flex justify-content-between align-items-center text-center text-lg-left"
          v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') || (loggedInRole != 'SecretaryOnly' && (memberDetails.id == loggedInId) && loggedInRole != 'Volunteer' && memberDetails.getedRole !== 'Volunteer') && !split && memberDetails ? memberDetails.product_options.length > 0 || (memberDetails.secondaries ? memberDetails.secondaries.some(member => member.product_options.length > 0) : false) : false"
        >
          <span>
            Membership ready for payment.
            <span v-if="memberDetails.upgrade_available"><br>This member is eligible for upgrade.</span>
          </span>
          <button class="btn btn-block-mob btn-primary ml-lg-auto mt-2 mt-lg-0" @click.prevent="$emit('renew')">Pay Membership</button>
        </div>

        <div role="alert" class="alert alert-info mb-0 d-lg-flex justify-content-between align-items-center text-center text-lg-left" v-else-if="!split && memberDetails && memberDetails.upgrade_available">
          This member is eligible for upgrade.
          <button class="btn btn-block-mob btn-primary ml-lg-auto mt-2 mt-lg-0" @click.prevent="$emit('renew')">Upgrade Membership</button>
        </div>

        <VueSlideToggle class="pt-2" :open="selectedSection === 'details' || !$store.state.showExpand" id="details" aria-labelledby="detailsHeading">
          <div class="f-form pt-3">
            <div class="f-form__full" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberDetails.getedRole !== 'Volunteer' ">
              <strong>Financial Seasons: </strong>
              <span v-for="(value, key, index) in memberDetails.seasons" :key="key">
                <span
                :class="['badge ml-1 my-auto', {'alert-danger': value === 0, 'alert-success': value === 1}]"
                :title="[ value === 0 ? 'Unfinancial' : 'Financial']">{{ key }}</span>
              </span>
            </div>
            <div class="f-form__full form-group" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')">
              <label for="notes">Notes</label>
              <textarea class="form-control" id="notes" v-model="memberUpdate.notes"></textarea>
            </div>
            <div class="f-form__pair f-form__pair--1-3">

              <div class="form-group">
                <label for="title">Title</label>
                <select
                  class="form-control"
                  id="title"
                  required
                  v-model="memberUpdate.title"
                  :disabled="disableField"
                >
                  <option disabled></option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                </select>
                <div class="invalid-tooltip">Please include your title.</div>
              </div>

              <div class="form-group">
                <label for="firstName">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  required v-model="memberUpdate.first_name"
                  :disabled="disableField"
                >
                <div class="invalid-tooltip">Please include your First Name.</div>
              </div>
            </div>
            <div class="f-form__half form-group">
              <label for="lastName">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                required
                v-model="memberUpdate.last_name"
                :disabled="disableField"
              >
              <div class="invalid-tooltip">Please include your Last Name.</div>
            </div>
            <div class="f-form__pair">
              <div class="form-group">
                <label for="gender">Gender</label>
                  <select
                    class="form-control"
                    id="gender"
                    required
                    v-model="memberUpdate.gender"
                    :disabled="disableField"
                  >
                  <option disabled></option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Unspecified</option>
                </select>
                <small v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberUpdate.gender === 'Female'">Lady Rider</small>
              </div>

              <div class="form-group">
                <label for="riderStatus">Rider Status</label>
                <select
                  class="form-control"
                  id="riderStatus"
                  :required="loggedInRole !== 'Member' && loggedInRole !== 'Secretary'"
                  v-model="memberUpdate.rider_status_id"
                  :disabled="disableField || (loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')"
                >
                  <option disabled :selected="!memberUpdate.rider_status_id"></option>
                  <option v-for="(status, statusIndex) in $store.state.riderStatus" :key="statusIndex" :value="status.id" :selected="memberUpdate.rider_status_id === status.id">{{status.name}}</option>
                </select>
                <small v-if="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">If you need to update your status please contact the ACA office in business hours</small>
                <div class="invalid-tooltip">Please include the Rider Status.</div>
              </div>
            </div>

            <div class="f-form__half form-group">
              <label for="dateOfBirth">Date of Birth</label>
              <input
                v-model="memberUpdate.dateOfBirth"
                :max="today()"
                required
                :class="['form-control form-date pl-md-2 pr-md-0 px-xl-3', errorStatus === 'dob' ? 'is-invalid' : '']"
                :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']"
                pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                id="dateOfBirth"
                type="date"
                @change="calcType(-1)"
                :disabled="disableField"
              >
              <small v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')">{{isUnder8 ? 'Mini' : isUnder13 ? 'Junior' : isUnder17 ? 'Juvenile' : isUnder21 ? 'Associate' : isOver55 ? 'Master Rider' : ''}}</small>
              <div class="invalid-tooltip">Please include your Date of Birth{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
            </div>
            <div class="f-form__half form-group" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberUpdate.boy_status_id">
              <label for="boyStatus">Beginning of Year Status</label>
              <select class="form-control" id="boyStatus" required v-model="memberUpdate.boy_status_id">
                <option disabled :selected="!memberUpdate.boy_status_id"></option>
                <option v-for="(status, statusIndex) in $store.state.riderStatus" :key="statusIndex" :value="status.id" :selected="memberUpdate.boy_status_id === status.id">{{status.name}}</option>
              </select>
              <div class="invalid-tooltip">Please include the Rider Status.</div>
            </div>
            <div class="f-form__half form-group" v-if="memberDetails.primary != null">
              <label :for="`secondary_email`">Email</label>
              <input
                type="email"
                :class="['form-control', errorStatus === 'secondary_email' ? 'is-invalid' : '']"
                :id="`secondary_email`"
                v-model="memberUpdate.secondary_email"
                maxlength="40"
              >
              <div class="invalid-tooltip">{{ errorStatus === 'secondary_email' ? 'Please include correct email.' : '' }}</div>
            </div>
            <div class="f-form__half form-group" v-if="memberDetails.primary != null">
              <label :for="`secondary_phone`">Mobile number</label>
              <div class="invalid-tooltip">Please include the phone number.</div>
              <phone-input
                :class="[errorStatus === 'incorrect_phone' ? 'is-invalid' : '']"
                :id="`secondary_phone`"
                v-model="memberUpdate.secondary_phone" />
              <div class="invalid-tooltip">{{ errorStatus === 'incorrect_phone' ? 'Please include correct phone number.' : 'Please include your phone number.' }}</div>
              <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
              <test-phone-numbers />
              <phone-before-fix :value="phonesBeforeFix.secondary_phone" />
            </div>
            <div class="f-form__half form-group" v-if="memberDetails.primary != null">
              <label for="carbon_copy_mobile">CC Mobile <small class="d-inline-block">(optional)</small></label>
              <phone-input :class="[errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : '']" id="carbon_copy_mobile" v-model="memberDetails.carbon_copy_mobile" />
              <div class="invalid-tooltip">Please enter correct CC mobile</div>
              <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
              <test-phone-numbers />
              <phone-before-fix :value="phonesBeforeFix.carbon_copy_mobile" />
            </div>
            <div class="f-form__half form-group" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')">
              <label for="membershipStatus">Member Status</label>
              <select class="form-control px-md-2 px-xl-3" id="membershipStatus" required v-model="memberUpdate.membership_status" :disabled="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">
                <option disabled></option>
                <option value="Active">Active</option>
                <option value="Archived">Archived</option>
                <option value="Onhold">On Hold</option>
                <option value="Lifetime">Lifetime</option>
                <option value="Suspended">Suspended</option>
              </select>
              <div class="invalid-tooltip">Please include the Membership Status.</div>
            </div>
            <div class="f-form__half form-group" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') || memberUpdate.member_number">
              <label for="memberNumber">Member Number</label>
              <div class="input-append">
                <input type="text" class="form-control" id="memberNumber" :class="['form-control', errorStatus === 'member_number' ? 'is-invalid' : '']" v-model="memberUpdate.member_number" :readonly="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">
                <span class="append badge badge-prim" v-if="memberDetails.primary === null && !memberUpdate.membership_type_id && (loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">Primary</span>
                <div class="invalid-tooltip">{{ errorStatus === 'member_number' ? 'Please include another member number.' : '' }}</div>
              </div>
            </div>
            <div
              class="f-form__half form-group"
              v-if="(loggedInRole !== 'SecretaryOnly') ||
                ((loggedInRole === 'SecretaryOnly') && (memberDetails.id != loggedInId))"
            >
              <label for="proofOfAge">Proof of Age</label>
              <div class="custom-file">
                <input type="file"
                       :class="['custom-file-input font-weight-normal', { 'is-invalid': errorStatus === 'file' }]"
                       id="proofOfAge" accept="image/*, application/pdf" :disabled="disableField" @change="fileUpload">
                <label :class="[{ 'no-after': disableField}, 'custom-file-label font-weight-normal']"
                       for="proofOfAge">{{ file_name ? file_name : 'Choose file...' }}</label>
                <small>jpg, jpeg, png, tiff, gif, pdf file type required.</small>
                <br>
                <small>Your ID will be stored in a secure data storage</small>
                <button
                  v-if="file_name"
                  type="button"
                  class="btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1"
                  :disabled="disableField"
                  @click="deleteAttachment"
                >
                  <span class="sr-only">Delete File</span>
                  <div class="btn-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 17 17">
                      <g fill="currentColor">
                        <path
                          d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/>
                        <path
                          d="M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"/>
                        <path
                          d="M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"/>
                      </g>
                    </svg>
                  </div>
                </button>
              </div>
              <div class="attached-file-wrapper" v-if="this.file_path">
                {{ this.exists_file_name }}
                <div
                  class="btn-remove-file"
                  v-if="!disableField || (loggedInRole === 'Secretary') || (loggedInRole === 'SecretaryOnly')"
                  @click="deleteExistsAttachment"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 17 17">
                    <g fill="currentColor">
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                    </g>
                  </svg>
                </div>
                <div class="btn-download-file" @click="downloadAgeProofFile(memberDetails.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 17 17">
                    <g fill="currentColor">
                      <path
                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path>
                      <path
                        d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"></path>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="f-form__half form-group" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberDetails.primary === null">
              <label for="role">Role</label>
              <select class="form-control px-md-2 px-xl-3" id="role" required v-model="memberUpdate.role" :disabled="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">
                <option value="Member">Member</option>
                <option value="Secretary">Secretary</option>
                <option value="Volunteer">Volunteer</option>
              </select>
            </div>
            <div class="f-form__full" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberDetails.primary === null && memberDetails.role === 'Secretary'">
              <super-secretary-toggle inline-alert :memberId="memberDetails.id" v-model="memberDetails.is_super_secretary" />
            </div>
            <div class="f-form__full d-block d-lg-none">
              <button :class="['btn btn-block d-lg-none mb-2', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit">
                {{ !processing ? split ? 'Publish' : 'Update Details' : '' }}
                <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
              </button>
              <button class="btn btn-outline-primary btn-block ml-lg-2" v-if="memberDetails ? !memberDetails.financial || (memberDetails.secondaries ? memberDetails.secondaries.some(member => member.financial === 0) : false) : false" @click.prevent="$emit('renew')">Pay Membership</button>
              <router-link class="btn btn-outline-primary btn-block ml-lg-2" v-if="memberDetails && (loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')" tag="a" :to="{ name: 'Nominate Rookie', params: { member: { id: memberDetails.id, name: memberDetails.first_name + ' ' + memberDetails.last_name } } }">Nominate Horses</router-link>
              <router-link class="btn btn-outline-primary btn-block ml-lg-2 mt-2" v-if="memberDetails && (loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')" tag="a" :to="{ name: 'Merge Member' }">Merge Accounts</router-link>
            </div>
          </div>
        </VueSlideToggle>
      </section>

      <section class="bg-white rounded mb-4 p-3 p-sm-4" v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')">
        <h2 class="mb-0">Membership Details</h2>
        <VueSlideToggle
          class="pt-2"
          :open="selectedSection === 'membership' || !$store.state.showExpand"
          id="membership"
          aria-labelledby="membershipHeading"
        >
          <div class="col-12 col-md-auto form-group">
            <label for="effectiveDate">Effective Date</label>
            <input
              v-model="memberUpdate.effective_date"
              :class="['form-control form-date pl-md-2 pr-md-0 px-xl-3', errorStatus === 'effective_date' ? 'is-invalid' : '']"
              :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']"
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
              id="effectiveDate"
              type="date"
            />
            <div class="invalid-tooltip">Please include Effective Date{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
          </div>
        </VueSlideToggle>
      </section>

      <section class="bg-white rounded mb-4 p-3 p-sm-4" v-if="memberDetails.primary === null || split">
        <div class="d-flex align-items-center" :aria-expanded="selectedSection === 'contact'" aria-controls="contact" id="contactHeading" @click.prevent="selectedSection !== 'contact' ? selectedSection = 'contact' : selectedSection = 'null'">
          <h2 class="mb-0">Contact Details</h2>
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-if="selectedSection === 'contact' && $store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg==">
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-else-if="$store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+">
        </div>

        <VueSlideToggle class="pt-2" :open="selectedSection === 'contact' || !$store.state.showExpand" id="contact" aria-labelledby="contactHeading">
          <div class="row pt-3">
            <div class="col-12 col-md-6 form-group">
              <label for="email">Email Address</label>
              <input type="email" :class="['form-control', errorStatus === 'email' && errors ? 'is-invalid' : '']" id="email" required v-model="memberDetails.attributes.email">
              <div class="invalid-tooltip">{{ errorStatus === 'email' && errors ? errors : 'Please include correct Email Address.' }}</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="phone">Phone Number</label>
              <input type="text" class="form-control" id="phone" v-model="memberDetails.attributes.phone" :required="!memberDetails.attributes.mobile_phone">
              <div class="invalid-tooltip">Please include either a Phone or Mobile Number.</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="mobile">Mobile Number <small class="d-inline-block">(optional)</small></label>
              <phone-input :class="[errorStatus === 'mobile_phone' && memberDetails.attributes.mobile_phone != '' ? 'is-invalid' : '']" id="mobile" v-model="memberDetails.attributes.mobile_phone" :required="!memberDetails.attributes.phone" />
              <div class="invalid-tooltip">Please enter the correct mobile number</div>
              <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
              <test-phone-numbers />
              <phone-before-fix :value="phonesBeforeFix.mobile_phone" />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="carbon_copy_mobile">CC Mobile <small class="d-inline-block">(optional)</small></label>
              <phone-input :class="[errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : '']" id="carbon_copy_mobile" v-model="memberDetails.carbon_copy_mobile" />
              <div class="invalid-tooltip">Please enter the correct CC mobile</div>
              <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
              <test-phone-numbers />
              <phone-before-fix :value="phonesBeforeFix.carbon_copy_mobile" />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="address1">Address Line 1</label>
              <input
                type="text"
                class="form-control"
                id="address1"
                required
                v-model="memberUpdate.attributes.address.street_1"
                :disabled="disableField"
              >
              <div class="invalid-tooltip">Please include your Address.</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="address2">Address Line 2 <small>(optional)</small></label>
              <input
                type="text"
                class="form-control"
                id="address2"
                v-model="memberUpdate.attributes.address.street_2"
                :disabled="disableField"
              >
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="suburb">Suburb</label>
              <input
                type="text"
                class="form-control"
                id="suburb"
                required
                v-model="memberUpdate.attributes.address.suburb"
                :disabled="disableField"
                @input="findZoneBy('suburb')"
              >
              <div class="invalid-tooltip">Please include your Suburb.</div>
            </div>
            <div class="col-12 col-md-6 row no-gutters">
              <div class="col-12 col-md-6 col-md-auto form-group">
                <label for="postcode">Postcode</label>
                <input
                  type="text"
                  class="form-control"
                  id="postcode"
                  required
                  v-model="memberUpdate.attributes.address.postcode"
                  pattern="\d{4}"
                  :disabled="disableField"
                  @input="findZoneBy('postcode')"
                >
                <div class="invalid-tooltip">Please include a four-digit Postcode.</div>
              </div>
              <div class="col-12 col-md-6 col-md pl-md-3 form-group">
                <label for="state">State</label>
                <select
                  class="form-control"
                  id="state"
                  required
                  v-model="memberUpdate.attributes.address.state"
                  :disabled="disableField"
                >
                  <option disabled></option>
                  <option value="QLD">Queensland</option>
                  <option value="NSW">New South Wales</option>
                  <option value="VIC">Victoria</option>
                  <option value="ACT">Australian Capital Territory</option>
                  <option value="SA">South Australia</option>
                  <option value="NT">Northern Territory</option>
                  <option value="WA">Western Australia</option>
                  <option value="TAS">Tasmania</option>
                </select>
                <div class="invalid-tooltip">Please include your State.</div>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-4 form-group">
              <label for="zone">Zone</label>
              <select class="form-control" id="zone" v-model="memberUpdate.attributes.zone_id" required :disabled="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">
                <option :value="null">Unspecified</option>
                <option v-for="(zone, index) in $store.state.listZones.filter(zone => !zone.deleted_at)" :key="index" :value="zone.id">{{zone.code}}</option>
              </select>
              <div class="invalid-tooltip">Please include your Zone.</div>
              <div class="alert alert-warning alert-sm" v-if="zoneNotFound">Unable to find matching Zone.</div>
              <div class="alert alert-success alert-sm" v-else-if="zoneFound">Found matching Zone.</div>
              <div class="alert alert-sm" v-else>&nbsp;</div>
            </div>

            <div class="col-12"></div>

            <div class="col-12 col-md-6 form-group">
              <label for="abn">ABN</label>
              <input
                type="number"
                :class="['form-control', errorStatus === 'abn' ? 'is-invalid' : '']"
                id="abn"
                v-model="memberDetails.attributes.abn"
                :disabled="disableField"
              >
              <div class="invalid-tooltip">ABN must be 11 digits.</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="bank_account_name">Bank Account Name</label>
              <input
                type="text"
                :class="['form-control', errorStatus === 'bank_account_name' ? 'is-invalid' : '']"
                id="bank_account_name"
                v-model="memberDetails.attributes.bank_account_name"
                maxlength="40"
                :required="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')"
                :disabled="disableField"
              >
              <div class="invalid-tooltip">Please include Bank Account Name.</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="bank_bsb">Bank BSB</label>
              <input
                type="text"
                :class="['form-control', errorStatus === 'bank_bsb' ? 'is-invalid' : '']"
                id="bank_bsb"
                v-model="memberDetails.attributes.bank_bsb"
                maxlength="40"
                :required="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')"
                :disabled="disableField"
                @input="validateBankBsb"
              >
              <div class="invalid-tooltip">Please enter the correct bank's BSB</div>
              <small>Please enter the bank's BSB in the format XXX-YYY</small>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="bank_account_number">Bank Account Number</label>
              <input
                type="text"
                :class="['form-control', errorStatus === 'bank_account_number' ? 'is-invalid' : '']"
                id="bank_account_number"
                v-model="memberDetails.attributes.bank_account_number"
                maxlength="40"
                :required="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')"
                :disabled="disableField"
                @input="validateBankAccountNumber"
              >
              <div class="invalid-tooltip">Please enter the correct Bank Account Number.</div>
            </div>
            <div class="col-12 form-group">
              <div class="form-group form-check px-0 mb-sm-4">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="gstRegistered"
                    v-model="memberDetails.attributes.gst_registered"
                    :disabled="disableField"
                  >
                  <label class="custom-control-label" for="gstRegistered">
                    I am GST Registered
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 form-group" v-if="isUnder17 || (memberUpdate.guardian.consent && isUnder17) || ((loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && isUnder17)">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" v-model="memberUpdate.guardian.consent" class="custom-control-input" id="parentalConsent" required>
                <label class="custom-control-label" for="parentalConsent">Parent or guardian gives consent.</label>
              </div>
            </div>
          </div>

          <div v-if="memberUpdate.guardian.consent && isUnder17">
            <h3 class="mb-4">Parent / Guardian Details</h3>
            <div class="row">
              <div class="col-12 col-md-6 pr-lg-2 form-group">
                <label for="parentFirstName">First Name</label>
                <input type="text" class="form-control" id="parentFirstName" required v-model="memberUpdate.guardian.first_name">
                <div class="invalid-tooltip">Please include the First Name.</div>
              </div>
              <div class="col-12 col-md-6 form-group">
                <label for="parentLastName">Last Name</label>
                <input type="text" class="form-control" id="parentLastName" required v-model="memberUpdate.guardian.last_name">
                <div class="invalid-tooltip">Please include the Last Name.</div>
              </div>
              <div class="col-12 col-md-6 pr-lg-2 form-group">
                <label for="parentEmail">Email Address</label>
                <input type="email" class="form-control" id="parentEmail" required v-model="memberUpdate.guardian.email">
                <div class="invalid-tooltip">Please include the Email Address.</div>
              </div>
              <div class="col-12 col-md-6 form-group">
                <label for="mobile">Phone Number</label>
                <input type="text" class="form-control" id="mobile" required v-model="memberUpdate.guardian.phone">
                <div class="invalid-tooltip">Please include the Phone Number.</div>
              </div>
            </div>
          </div>
          <div class="col-12 px-0 d-flex d-lg-none justify-content-end">
            <button class="btn btn-primary btn-block-mob" @click="handleSubmit">{{split ? 'Publish' : 'Update Details'}}</button>
          </div>
        </VueSlideToggle>
      </section>

      <section class="bg-white rounded mb-4 p-3 p-sm-4"
        v-if="(((loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') || loggedInRole === 'Member' || loggedInRole === 'Secretary' || loggedInRole === 'SecretaryOnly') && memberDetails.primary === null)"
      >
        <div class="d-flex align-items-center" :aria-expanded="selectedSection === 'vehicle'" aria-controls="vehicle" id="vehicleHeading" @click.prevent="selectedSection !== 'vehicle' ? selectedSection = 'vehicle' : selectedSection = 'null'">
          <h2 class="mb-0">Truck/vehicle Details</h2>
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-if="selectedSection === 'vehicle' && $store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg==">
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-else-if="$store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+">
        </div>

        <div role="alert" class="alert alert-warning mt-3" v-if="vehicleErrors">{{vehicleErrors}}</div>

        <VueSlideToggle class="pt-2" :open="selectedSection === 'vehicle' || !$store.state.showExpand" id="vehicle" aria-labelledby="vehicleHeading">
          <div class="row pt-3">
            <div class="col-12 col-md-6 form-group">
              <label for="vehicleRegistration">Registration </label>
              <input :type="'text'" class="form-control" v-model="vehicle.registration" id="vehicleRegistration">
              <div class="invalid-tooltip">Please ensure your Password matches.</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="vehicleSize">Size</label>
              <select class="form-control" id="vehicleSize" v-model="vehicle.size">
                <option v-for="(size) in $store.state.listVehiclesSizes" :key="size.id" :value="size.id">{{size.name}}</option>
              </select>
              <div class="invalid-tooltip">Please include the size.</div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-12 col-md-6 form-group">
              <label for="vehicleType">Type</label>
              <select class="form-control" id="vehicleType" v-model="vehicle.type">
                <option v-for="(type) in $store.state.listVehiclesTypes" :key="type.id" :value="type.id">{{type.name}}</option>
              </select>
              <div class="invalid-tooltip">Please include the type</div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-12 col-md-6 form-group">
              <button class="btn btn-primary" @click="addVehicle">Add Vehicle</button>
            </div>
          </div>
          <div class="row pt-3">
            <table class="table table-striped table-bordered border-0">
              <thead>
                <tr>
                  <th class="position-relative">Registration</th>
                  <th class="position-relative">Size</th>
                  <th class="position-relative">Type</th>
                  <th class="position-relative"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="vehicle in memberUpdate.vehicles" :key="vehicle.id">
                  <td>{{ vehicle.registration }}</td>
                  <td>{{ vehicle.size ? vehicle.size.name : null }}</td>
                  <td>{{ vehicle.type ? vehicle.type.name : null }}</td>
                  <td>
                    <a href="#" @click.prevent="removeVehicle(vehicle.id)">Remove</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </VueSlideToggle>
      </section>

      <section
        class="bg-white rounded mb-4 p-3 p-sm-4"
        v-if="(memberDetails.primary === null || split) && ((loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') || this.my)"
      >
        <div class="d-flex align-items-center" :aria-expanded="selectedSection === 'login'" aria-controls="login" id="loginHeading" @click.prevent="selectedSection !== 'login' ? selectedSection = 'login' : selectedSection = 'null'">
          <h2 class="mb-0">Login Details</h2>
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-if="selectedSection === 'login' && $store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg==">
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-else-if="$store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+">
        </div>

        <VueSlideToggle class="pt-2" :open="selectedSection === 'login' || !$store.state.showExpand" id="login" aria-labelledby="loginHeading">
          <div class="row pt-3">
            <div class="col-12 col-md-6 pr-lg-2 form-group">
              <label for="password">Password</label>
              <input :type="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin') ? 'password' : 'text'" class="form-control" id="password" v-model="password.password" :required="split" pattern="([A-Za-z0-9]){6,}">
              <div class="invalid-tooltip">Please include a Password between 6 and 30 characters, using only letters and numbers.</div>
              <small class="d-block">Must be between 6 and 30 characters, using only letters and numbers</small>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="confirmPassword">Confirm Password</label>
              <input :type="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin') ? 'password' : 'text'" class="form-control" id="confirmPassword" v-model="password.confirmPassword" :required="confirmRequired">
              <div class="invalid-tooltip">Please ensure your Password matches.</div>
            </div>

            <div class="col-12 d-flex d-lg-none justify-content-end">
              <button class="btn btn-primary btn-block-mob d-lg-none" @click="handleSubmit">{{split ? 'Publish' : 'Update Details'}}</button>
            </div>
          </div>
        </VueSlideToggle>
      </section>

      <section
        class="bg-white rounded mb-4 p-3 p-sm-4"
        v-if="((loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')) ||
          ((loggedInRole === 'Member' || loggedInRole === 'Secretary') && memberUpdate.judge && memberUpdate.judge.status) && !memberUpdate.judge.is_suspended"
      >
        <div
          class="d-flex align-items-center"
          :aria-expanded="selectedSection === 'judge'"
          aria-controls="judge" id="judgeHeading"
          @click.prevent="selectedSection !== 'judge' ? selectedSection = 'judge' : selectedSection = 'null'"
        >
          <h2 class="mb-0">Judge Details</h2>
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-if="selectedSection === 'login' && $store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg==">
          <img width="13" height="6" class="ml-auto" aria-hidden="true" alt="" v-else-if="$store.state.showExpand" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+">
        </div>

        <VueSlideToggle class="pt-2" :open="selectedSection === 'judge' || !$store.state.showExpand" id="judge" aria-labelledby="judgeHeading">
          <div class="row">
            <div class="col-12 col-md-6 pr-lg-2 form-group">
              <label for="zone">Status</label>
              <select class="form-control" id="judge_status" v-model="memberUpdate.judge.status" :disabled="(loggedInRole !== 'Admin' && loggedInRole !== 'SuperAdmin')">
                <option :value="null">-</option>
                <option :value="'trial'">Trial</option>
                <option :value="'open'">Open</option>
              </select>
              <div class="invalid-tooltip">Please, select a judge status</div>
            </div>
          </div>
          <div
            class="row"
            v-if="memberUpdate.judge && memberUpdate.judge.status"
          >
            <div class="col-12 col-md-6 pr-lg-2 form-group">
              <label for="judge_email">Additional Judge Email</label>
              <input
                :type="'text'"
                :class="['form-control', errorStatus === 'judge_email' ? 'is-invalid' : '']"
                id="judge_email"
                v-model="memberUpdate.judge.judge_email"
              >
              <div class="invalid-tooltip">Please enter the valid email address</div>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="judge_phone">Additional Judge Phone</label>
              <phone-input
                :class="[errorStatus === 'judge_phone' ? 'is-invalid' : '']"
                id="judge_phone"
                v-model="memberUpdate.judge.judge_phone" />
              <div class="invalid-tooltip">Please enter the correct judge phone number.</div>
              <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
              <test-phone-numbers />
              <phone-before-fix :value="phonesBeforeFix.judge_phone" />
            </div>
          </div>
          <div
            class="row"
            v-if="memberUpdate.judge && memberUpdate.judge.status"
          >
            <div class="col-12 form-group">
              <div class="form-group form-check px-0 mb-sm-4">
                <div class="custom-control custom-checkbox d-flex flex-column">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="isCallFirst"
                    v-model="memberUpdate.judge.is_call_first"
                  >
                  <label class="custom-control-label" for="isCallFirst">
                    I would like to appear on the Call First list on the ACA Judges Register
                  </label>
                  <small>
                    By selecting this box you acknowledge you are happy to be approached by committees first who
                    are seeking judges for their event
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            v-if="memberUpdate.judge && memberUpdate.judge.status && memberUpdate.judge.judge_app_id"
          >
            <div class="col-12 form-group">
              <div class="form-group form-check px-0 mb-sm-4">
                  <button class="btn btn-primary btn-block-mob" @click="downloadJudgeApplication(memberUpdate.judge.judge_app_id)">Download Application</button>
              </div>
            </div>
          </div>
          <div
            class="col-12 d-flex pl-0 pr-0"
            v-if="memberUpdate.judge && memberUpdate.judge.status && loggedInRole == 'Admin'"
          >
            <button class="btn btn-primary btn-block-mob" @click="makeJudge">Make a judge</button>
          </div>
        </VueSlideToggle>
      </section>
    </div>

    <div class="bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3" v-else>
      <div class="text-center p-2">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <desktop-action-bar>
      <button :class="['btn btn-block mb-2', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit">
        {{ !processing ? split ? 'Publish' : 'Update Details' : '' }}
        <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
      </button>
      <button v-if="(loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && !split && memberDetails.primary === null" class="btn btn-block btn-outline-primary mb-2" @click.prevent="joinMembers">Join</button>
      <router-link class="btn btn-block btn-outline-primary mb-2" v-if="memberDetails && (loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')" tag="a" :to="{ name: 'Nominate Rookie', params: { member: { id: memberDetails.id, name: memberDetails.first_name + ' ' + memberDetails.last_name } } }">Nominate Horses</router-link>
      <button class="btn btn-block btn-outline-primary" v-if="split" @click="$router.push('/members/member-profile')">Cancel</button>
      <div v-else>
        <button
          class="btn btn-block btn-outline-primary"
          v-if="memberDetails ? ((loggedInRole != 'SecretaryOnly' && loggedInRole != 'Volunteer' && memberDetails.getedRole !== 'Volunteer') && !memberDetails.financial) || (memberDetails.secondaries ? memberDetails.secondaries.some(member => member.financial === 0) : false) : false"
          @click.prevent="$emit('renew')"
        >
          Pay Membership
        </button>
      </div>
      <router-link v-if="memberDetails && (loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin')" class="btn btn-block btn-primary mt-2" tag="a" :to="{ name: 'Merge Member' }">Merge Accounts</router-link>
      <button
        v-if="memberDetails && (loggedInRole === 'Admin' || loggedInRole === 'SuperAdmin') && memberDetails.role !== 'Admin' && String(memberDetails.id) !== String(loggedInId)"
        type="button"
        class="btn btn-block btn-outline-primary mt-2"
        @click.prevent="deleteConfirm = true"
      >
        Delete
      </button>
      <button
        v-if="memberDetails && loggedInRole === 'SuperAdmin' && String(memberDetails.id) !== String(loggedInId)"
        type="button"
        class="btn btn-block btn-primary mt-2"
        :disabled="loggingIn"
        @click.prevent="loginAsMember"
      >
        <span v-if="loggingIn" class="spinner-border spinner-border-sm text-light" role="status" />
        <span v-else>Login</span>
      </button>
    </desktop-action-bar>

    <confirm-modal
      v-if="deleteConfirm"
      :message="deleteConfirmMessage"
      :loading="deleting"
      @confirm="deleteMember"
      @cancel="deleteConfirm = false"
    />
  </form>

</template>

<script>
import { storeSuperSecretaryFlags } from '@/services/actingCommittee'
import axios from 'axios'
import SuperSecretaryToggle from '@/components/Members/SuperSecretaryToggle'
import { VueSlideToggle } from 'vue-slide-toggle'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import CALCTYPE from '@/mixins/calcType.js'
// import eventBus from '@/store/EventBus.js'
import DesktopActionBar from '@/components/DesktopActionBar'
import ConfirmModal from '@/components/ConfirmModal'
import PhoneInput from '@/components/FormFields/PhoneInput'
import PhoneBeforeFix from '@/components/PhoneBeforeFix'
import TestPhoneNumbers from '@/components/TestPhoneNumbers'

export default {
  name: 'MembersProfileDetails',
  props: ['memberDetails', 'split', 'my', 'completePaymentProfile', 'returnTo'],
  mixins: [HANDLESUBMIT, LEGACYBROWSERS, CALCTYPE],
  components: {
    TestPhoneNumbers,
    PhoneInput,
    PhoneBeforeFix,
    VueSlideToggle,
    DesktopActionBar,
    ConfirmModal,
    SuperSecretaryToggle
  },
  data() {
    return {
      zoneLocations: [],
      zoneNotFound: false,
      zoneFound: false,
      selectedSection: this.completePaymentProfile ? 'contact' : 'details',
      success: '',
      errors: '',
      errorStatus: '',
      memberUpdate: {
        judge: {
          status: null,
          judge_email: '',
          judge_phone: '',
          is_call_first: false,
          judge_app_id: null
        },
        attributes: {
          status: null,
          address: {}
        },
        zone: {},
        dateOfBirth: '',
        guardian: { consent: false },
        vehicles: {
          registration: '',
          size: '',
          type: ''
        }
      },
      loggedInRole: localStorage.role,
      loggedInId: localStorage.userID,
      deleteConfirm: false,
      deleting: false,
      loggingIn: false,
      processing: false,
      disableField: false,
      file_name: '',
      file: '',
      file_path: '',
      exists_file_name: '',
      judge_application_file: '',
      vehicle: {
        registration: '',
        size: '',
        type: ''
      },
      vehicleErrors: ''
    }
  },
  mounted() {
    this.initialiseMember()
    this.getZoneLocations()
  },
  watch: {
    memberDetails: {
      handler() {
        this.errors = ''
        if (!this.memberUpdate.hasOwnProperty('id')) {
          this.memberUpdate = this.memberDetails
        } else {
          this.initialiseMember()
        }
        // Create attributes object if it doesn't exist
        if (this.memberUpdate.attributes === null) {
          this.memberUpdate.attributes = { address: {} }
        } else if (this.memberUpdate.attributes.address === null) {
          this.memberUpdate.attributes.address = {}
        }
        // Create attributes object if it doesn't exist
        if (this.memberUpdate.judge === null) {
          this.memberUpdate.judge = { status: null, judge_email: '', judge_phone: '', is_call_first: false, judge_app_id: null }
        }
        // Create guardian object if it doesn't exist
        if (this.memberUpdate.guardian === null) {
          this.memberUpdate.guardian = { consent: false }
        }
        if (this.memberDetails.password) {
          this.password = {
            password: this.memberDetails.password,
            confirmPassword: this.memberDetails.password
          }
        }
        if ((this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin') && this.memberUpdate.hasOwnProperty('user_memberships') && this.memberUpdate.user_memberships.length) {
          const effective_date = new Date(Math.max(...this.memberUpdate.user_memberships.map(e => new Date(e.effective_date)))).toISOString().substring(0, 10)
          this.effective_date = effective_date
          this.memberUpdate.effective_date = effective_date
        }
        if (this.memberUpdate.hasOwnProperty("dateOfBirth")) {
          this.dateOfBirth = this.memberUpdate.dateOfBirth
        } else if (this.memberDetails.hasOwnProperty("dob")) {
          this.dateOfBirth = this.memberDetails.dob
          this.memberUpdate.dateOfBirth = this.memberDetails.dob
        }
        if (this.memberUpdate.attributes.bank_bsb?.length > 7) {
          this.memberUpdate.attributes.bank_bsb = this.memberUpdate.attributes.bank_bsb.slice(0, 7)
        }
      },
      deep: true
    }
  },
  computed: {
    phonesBeforeFix() {
      return (this.memberDetails && this.memberDetails.phones_before_fix) || {}
    },
    deleteConfirmMessage() {
      let message = `You are about to delete ${this.memberDetails.first_name} ${this.memberDetails.last_name}. Are you sure?`
      if (this.memberDetails.primary === null && this.memberDetails.secondaries && this.memberDetails.secondaries.length > 0) {
        // TODO: cascading delete of secondary accounts is not implemented yet — this is a heads-up only for now.
        message += ' This is a primary account — deleting it will also delete all of its secondary accounts.'
      }
      return message
    }
  },
  methods: {
    deleteMember() {
      this.deleting = true
      axios.delete(`${this.$api}/v2/members/${this.memberUpdate.id}`).then(() => {
        this.$router.push('/admin-members')
      }).catch((error) => {
        this.deleting = false
        this.deleteConfirm = false
        this.errors = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'There was a server error. Please try again later.'
      })
    },
    // Same as the "Login" column button in the members list (Members/Listing/Members.vue).
    loginAsMember() {
      if (this.loggingIn) return
      this.loggingIn = true
      const id = this.memberDetails.parent_id || this.memberDetails.id
      axios.post(`${this.$api}/auth/login-as-user`, { id }).then((response) => {
        if (response.data.token) {
          localStorage.setItem('bearer', response.data.token)
          axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
          localStorage.setItem('first_name', response.data.first_name)
          localStorage.setItem('last_name', response.data.last_name)
          localStorage.setItem('role', response.data.role)
          localStorage.setItem('userID', response.data.id)
          localStorage.setItem('is_onboarded', response.data.is_onboarded)
          storeSuperSecretaryFlags(response.data, { resetSelection: true })
          this.$router.push('/')
        } else {
          this.loggingIn = false
          this.errors = 'Unable to log in as this member.'
        }
      }).catch(() => {
        this.loggingIn = false
        this.errors = 'Unable to log in as this member.'
      })
    },
    addVehicle() {
      axios.post(`${this.$api}/saveVehicle/`, { vehicle: this.vehicle, user_id: this.memberUpdate.id }).then((response) => {
        if (response.data.status === 'success') {
          this.memberUpdate.vehicles.push({
            id: response.data.vehicle.id,
            registration: response.data.vehicle.registration,
            size: response.data.vehicle.size,
            type: response.data.vehicle.type
          })

          this.vehicle = {
            registration: '',
            size: '',
            type: ''
          }
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.registration']) {
          this.success = ''
          this.errorStatus = 'vehicle_registration'
          this.vehicleErrors = `${response.data.errors['vehicle.registration'][0]}`
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.size']) {
          this.success = ''
          this.errorStatus = 'vehicle_size'
          this.vehicleErrors = `${response.data.errors['vehicle.size'][0]}`
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.type']) {
          this.success = ''
          this.errorStatus = 'vehicle_type'
          this.vehicleErrors = `${response.data.errors['vehicle.type'][0]}`
        }
      }).catch(() => {
        this.vehicleErrors = 'Something went wrong. Please, reload page and try again.'
      })
    },
    removeVehicle(vehicle_id) {
      axios.post(`${this.$api}/removeVehicle/${vehicle_id}`).then((response) => {
        if (response.data.status === 'success') {
          const i = this.memberUpdate.vehicles.map(item => item.id).indexOf(vehicle_id)
          this.memberUpdate.vehicles.splice(i, 1)
        }
      }).catch(() => {
        this.vehicleErrors = 'Something went wrong. Please, reload page and try again.'
      })
    },
    findZoneBy(value) {
      let zone = {}
      if (value === 'postcode') {
        zone = this.zoneLocations.find(
          ({ postcode }) => this.memberUpdate.attributes.address.postcode === postcode
        ) || {}
        if (zone.suburb) {
          this.memberUpdate.attributes.address.suburb = zone.suburb
        }
      } else if (value === 'suburb') {
        zone = this.zoneLocations.find(
          ({ suburb }) => this.memberUpdate.attributes.address.suburb.toUpperCase() === suburb.toUpperCase()
        ) || {}
        if (zone.postcode) {
          this.memberUpdate.attributes.address.postcode = zone.postcode
        }
      }
      this.memberUpdate.attributes.zone_id = zone.zone_id
      if (zone.zone_id) {
        this.zoneNotFound = false
        this.zoneFound = true
      } else {
        this.zoneNotFound = true
        this.zoneFound = false
      }
    },
    async getZoneLocations() {
      try {
        const { data: { data } } = await axios.get(`${this.$api}/zone-location/list`)
        this.zoneLocations = data || []
      } catch (error) {
        // Can't fetch zone locations error
      }
    },
    initialiseMember() {
      if (this.memberDetails) {
        this.disableField = (Number(localStorage.userID) !== this.memberDetails.id) &&
          ((this.loggedInRole === 'Secretary' || this.loggedInRole === 'SecretaryOnly') && (Number(localStorage.userID) !== this.memberDetails.parent_id))
        this.memberUpdate = this.memberDetails
        // Create attributes object if it doesn't exist
        if (this.memberUpdate.attributes === null) {
          this.memberUpdate.attributes = { address: {} }
        }
        // Create guardian object if it doesn't exist
        if (this.memberUpdate.guardian === null) {
          this.memberUpdate.guardian = { consent: false }
        }
        if (this.memberDetails.password && (this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin')) {
          this.password = {
            password: this.memberDetails.password,
            confirmPassword: this.memberDetails.password
          }
        }
        if (this.memberDetails.judge === null) {
          this.memberDetails.judge = { status: null, judge_email: '', judge_phone: '', is_call_first: false, judge_app_id: null }
        }
        this.file_path = this.memberDetails.age_proof_file_path
        this.exists_file_name = this.memberDetails.age_proof_file_name
        if (this.memberDetails.judge.judge_app_id !== null) {
          this.judge_application_file = this.memberDetails.judge_applications.find(app => app.id === this.memberDetails.judge.judge_app_id).file_path
        }
        if (this.memberDetails.vehicles) {
          this.memberUpdate.vehicles = this.memberDetails.vehicles
        }
      }
    },
    updateMember(member) {
      if (!this.errors) {
        if (this.file && this.file.size > 1024 * 1024) {
          this.success = ''
          this.errorStatus = 'file'
          this.errors = `The Proof of Age file may not be greater than 1 mb.`
        }
        this.processing = true

        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('fields', JSON.stringify(member))
        const postURL = this.memberDetails.primary === null ? `${this.$api}/user/${this.memberUpdate.id}` : `${this.$api}/update-secondary`
        axios.post(postURL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            this.processing = false
            if (response.data.status === 'success') {
              // Done
              this.success = 'The member has been updated successfully.'
              this.errors = ''
              this.errorStatus = ''
              this.memberDetails.getedRole = this.memberDetails.role
              if (this.returnTo) {
                this.$router.push(this.returnTo)
              } else {
                location.reload()
              }
            } else {
              this.fieldsValidation(response)
            }
          })
          .catch((error) => {
            this.processing = false
            this.success = ''

            if (error.response.status === 413) {
              this.errorStatus = 'file'
              this.errors = `The Proof of Age file may not be greater than 1 mb.`
            }

            this.errors = 'There was a server error. Please try again later.'
            this.errorStatus = ''
            // eslint-disable-next-line
            console.log(error)
          })
      }
    },
    splitMember(member) {
      this.processing = true
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('fields', JSON.stringify(member))
      axios.post(`${this.$api}/admin/split`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          // Done
          this.success = 'The member has been updated successfully.'
          this.errors = ''
          this.errorStatus = ''
          this.memberDetails.getedRole = this.memberDetails.role
          location.reload()
        } else {
          this.fieldsValidation(response)
        }
      }).catch((error) => {
        this.processing = false
        this.success = ''
        this.errors = 'There was a server error. Please try again later.'
        // eslint-disable-next-line
        console.log(error)
      })
    },
    update(event) {
      event.preventDefault()
      const member = {
        id: this.memberUpdate.id,
        title: this.memberUpdate.title,
        first_name: this.memberUpdate.first_name,
        secondary_email: this.memberUpdate.secondary_email,
        secondary_phone: this.memberUpdate.secondary_phone,
        last_name: this.memberUpdate.last_name,
        dob: this.memberUpdate.dateOfBirth,
        gender: this.memberUpdate.gender,
        rider_status_id: this.memberUpdate.rider_status_id,
        membership_status: this.memberUpdate.membership_status,
        member_number: this.memberUpdate.member_number,
        membership_type_id: this.memberUpdate.membership_type_id,
        email: this.memberUpdate.attributes.email,
        phone: this.memberUpdate.attributes.phone,
        mobile_phone: this.memberUpdate.attributes.mobile_phone ? this.memberUpdate.attributes.mobile_phone : '',
        carbon_copy_mobile: this.memberUpdate.carbon_copy_mobile,
        street_1: this.memberUpdate.attributes.address.street_1,
        street_2: this.memberUpdate.attributes.address.street_2 ? this.memberUpdate.attributes.address.street_2 : null,
        suburb: this.memberUpdate.attributes.address.suburb,
        postcode: this.memberUpdate.attributes.address.postcode,
        state: this.memberUpdate.attributes.address.state,
        zone_id: this.memberUpdate.attributes.zone_id,
        primary_id: this.memberUpdate.primary ? this.memberUpdate.primary.id : null,
        notes: this.memberUpdate.notes,
        boy_status_id: this.memberUpdate.boy_status_id,
        role: this.memberUpdate.role ? this.memberUpdate.role : 'Member',
        abn: this.memberUpdate.attributes.abn,
        bank_account_name: this.memberUpdate.attributes.bank_account_name,
        bank_bsb: this.memberUpdate.attributes.bank_bsb,
        bank_account_number: this.memberUpdate.attributes.bank_account_number,
        gst_registered: this.memberDetails.attributes.gst_registered ? this.memberDetails.attributes.gst_registered : null,
        effective_date: this.memberUpdate.effective_date !== '' ? this.memberUpdate.effective_date : null,
        file_path: this.file_path,
        // Judge
        judge_status: this.memberDetails.judge ? this.memberDetails.judge.status : null,
        judge_email: this.memberUpdate.judge ? this.memberUpdate.judge.judge_email : null,
        judge_phone: this.memberUpdate.judge ? this.memberUpdate.judge.judge_phone : null,
        is_call_first: this.memberDetails.judge ? this.memberDetails.judge.is_call_first : null
      }
      if (this.password.password.length > 0) {
        member.password = this.password.password
        member.password_confirmation = this.password.confirmPassword
      }
      if (this.isUnder17) {
        member.guardian = this.memberUpdate.guardian
      }
      setTimeout(() => {
        if (this.formComplete) {
          if (this.split) {
            this.splitMember(member)
          } else {
            this.updateMember(member)
          }
        }
      }, 10)
    },
    joinMembers() {
      this.$store.commit('deselectAllRows')
      this.$router.push({ name: 'Join Members', params: { primary: this.memberDetails } })
    },
    downloadAgeProofFile(user_id) {
      axios.get(`${this.$api}/user/download/${user_id}`)
        .then((response) => {
          window.open(response.data.path, '_blank')
        })
    },
    fileUpload(event) {
      this.errorStatus = ''
      this.errors = ''
      this.file_name = ''
      const uploadedFile = event.target.files[0]
      this.file = uploadedFile
      if (uploadedFile && uploadedFile.size > 1024 * 1024) {
        this.success = ''
        this.errorStatus = 'file'
        this.errors = `The Proof of Age file may not be greater than 1 mb.`
      }
      if (uploadedFile) {
        this.file_name = uploadedFile.name
      }
    },
    deleteAttachment() {
      delete this.file
      this.file = undefined
      this.file_name = ''
      this.errorStatus = ''
      this.errors = ''
    },
    deleteExistsAttachment() {
      this.file_path = ''
      this.exists_file_name = ''
    },
    makeJudge() {
      axios.post(`${this.$api}/judges`, {
        user_id: this.memberUpdate.id,
        status: this.memberUpdate.judge.status ? this.memberUpdate.judge.status : '',
        judge_email: this.memberUpdate.judge.judge_email ? this.memberUpdate.judge.judge_email : '',
        judge_phone: this.memberUpdate.judge.judge_phone ? this.memberUpdate.judge.judge_phone : '',
        is_call_first: this.memberUpdate.judge.is_call_first
      }).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          // Done
          this.success = 'The member was successfully made a judge.'
          this.errors = ''
          this.errorStatus = ''
          this.memberDetails.getedRole = this.memberDetails.role
          location.reload()
        } else if (response.data.status === 'validation_error' && response.data.errors.judge_email) {
          this.success = ''
          this.errorStatus = 'judge_email'
          this.errors = `Please enter the correct email address`
        } else if (response.data.status === 'validation_error' && response.data.errors.judge_phone) {
          this.success = ''
          this.errorStatus = 'judge_phone'
          this.errors = `Please enter the correct mobile phone number`
        }
      })
    },
    downloadJudgeApplication(id) {
      axios.get(`${this.$api}/admin/judges-app-download/${id}`)
        .then((response) => {
          window.open(response.data.path, '_blank')
        })
    },
    fieldsValidation(data) {
      if (data.data.status === 'validation_error') {
        if (data.data.errors.dob) {
          // DoB
          this.success = ''
          this.errorStatus = 'dob'
          this.errors = `Please include your Date of Birth in the format${this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy'}.`
        } else if (data.data.errors.email) {
          // Email
          this.success = ''
          this.errorStatus = 'email'
          if (data?.data?.errors?.email[0]) {
            this.errors = data.data.errors.email[0]
          } else {
            this.errors = 'Please include correct email address.'
          }
        } else if (data.data.errors.secondary_phone) {
          // Phone Exists
          this.success = ''
          this.errorStatus = 'incorrect_phone'
          this.errors = `Please include correct phone number`
        } else if (data.data.errors.member_number) {
          // Member number Exists
          this.success = ''
          this.errorStatus = 'member_number'
          this.errors = `The member number has already been taken.`
        } else if (data.data.errors.mobile_phone) {
          // Mobile Phone Correct
          this.success = ''
          this.errorStatus = 'mobile_phone'
          this.errors = `Please enter correct mobile number`
        } else if (data.data.errors.bank_account_name) {
          // Bank account name is not empty
          this.success = ''
          this.errorStatus = 'bank_account_name'
          this.errors = `Please enter the bank account name`
        } else if (data.data.errors.carbon_copy_mobile) {
          // Carbon Copy Mobile Correct
          this.success = ''
          this.errorStatus = 'carbon_copy_mobile'
          this.errors = `Please enter correct CC mobile`
        } else if (data.data.errors.abn) {
          // ABN must be 11 digits
          this.success = ''
          this.errorStatus = 'abn'
          this.errors = `ABN must be 11 digits.`
        } else if (data.data.errors.secondary_email) {
          // Secondary email
          this.success = ''
          this.errorStatus = 'secondary_email'
          this.errors = `Please include correct email address.`
        } else if (data.data.errors.bank_bsb) {
          // Bank BSB must be 6 digits
          this.success = ''
          this.errorStatus = 'bank_bsb'
          this.errors = `Please enter the bank's BSB in the format XXX-YYY.`
        } else if (data.data.errors.bank_account_number) {
          // Bank Account Number
          this.success = ''
          this.errorStatus = 'bank_account_number'
          this.errors = `Please enter the correct Bank Account Number.`
        } else if (data?.data?.errors?.judge_phone) {
          // Bank Account Number
          this.success = ''
          this.errorStatus = 'judge_phone'
          this.errors = `Please enter the correct judge phone number.`
        } else if (data?.data?.errors?.file) {
          // Proof of Age file type
          this.success = ''
          this.errorStatus = 'file'
          this.errors = data.data.errors.file[0]
        }
      } else if (data?.data?.status === 'invalid_data' && data?.data?.message) {
        // Error
        this.success = ''
        this.errors = data.data.message
      } else {
        // Error
        this.success = ''
        this.errors = 'Please ensure all fields are completed.'
      }
    },
    validateBankAccountNumber(event) {
      const text = event.target.value.trim()
      this.memberDetails.attributes.bank_account_number = text.replace(/[^0-9]/, '')
    },
    validateBankBsb(event) {
      const value = event.target.value.replaceAll(/[^0-9]/g, '')
      const valueLength = value.length
      let newValue = value
      if (
        ((event.data === '-' && valueLength < 3) || event.inputType === 'insertFromPaste') ||
        ((event.data?.match(/[0-9]/) && valueLength === 3) || valueLength > 2)
      ) {
        newValue = `${value.replaceAll(/[^0-9]/g, '').slice(0, 3)}-${value.replaceAll(/[^0-9]/g, '').slice(3)}`
      }
      if (
        ((event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') && valueLength === 3) ||
        valueLength < 3
      ) {
        newValue = value.replaceAll(/[^0-9]/g, '')
      }

      this.memberDetails.attributes.bank_bsb = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-pane {

  section.rounded:first-child {
    border-top-left-radius: 0 !important;
  }
}

@media (min-width: 1024px) and (max-width: 1400px) {

  .form-group label {
    font-size: 0.91rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Members/Tabs/Details.vue